import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { useRepairTemplateModel } from "../repairTemplateModel";
export default () => {
    const {
        print,
        scaniaPrint: { visible },
        settleScaniaPrint,
    } = useRepairTemplateModel();
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}